/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLastShift200ResponseAmountsInner
 */
export interface GetLastShift200ResponseAmountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLastShift200ResponseAmountsInner
     */
    shiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastShift200ResponseAmountsInner
     */
    method: string;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200ResponseAmountsInner
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200ResponseAmountsInner
     */
    end?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200ResponseAmountsInner
     */
    expectedEnd?: number;
}

/**
 * Check if a given object implements the GetLastShift200ResponseAmountsInner interface.
 */
export function instanceOfGetLastShift200ResponseAmountsInner(value: object): value is GetLastShift200ResponseAmountsInner {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    return true;
}

export function GetLastShift200ResponseAmountsInnerFromJSON(json: any): GetLastShift200ResponseAmountsInner {
    return GetLastShift200ResponseAmountsInnerFromJSONTyped(json, false);
}

export function GetLastShift200ResponseAmountsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastShift200ResponseAmountsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'shiftId': json['shiftId'] == null ? undefined : json['shiftId'],
        'method': json['method'],
        'start': json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'expectedEnd': json['expectedEnd'] == null ? undefined : json['expectedEnd'],
    };
}

export function GetLastShift200ResponseAmountsInnerToJSON(json: any): GetLastShift200ResponseAmountsInner {
    return GetLastShift200ResponseAmountsInnerToJSONTyped(json, false);
}

export function GetLastShift200ResponseAmountsInnerToJSONTyped(value?: GetLastShift200ResponseAmountsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shiftId': value['shiftId'],
        'method': value['method'],
        'start': value['start'],
        'end': value['end'],
        'expectedEnd': value['expectedEnd'],
    };
}

